export const MAXIMUM_WIDTH = 840;
export const HALF_WIDTH = 724;
export const LOWEST_WIDTH = 420;
